<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3332 6.66927C13.3332 9.99794 9.6405 13.4646 8.4005 14.5353C8.28499 14.6221 8.14437 14.6691 7.99984 14.6691C7.85531 14.6691 7.71469 14.6221 7.59917 14.5353C6.35917 13.4646 2.6665 9.99794 2.6665 6.66927C2.6665 5.25478 3.22841 3.89823 4.2286 2.89803C5.2288 1.89784 6.58535 1.33594 7.99984 1.33594C9.41433 1.33594 10.7709 1.89784 11.7711 2.89803C12.7713 3.89823 13.3332 5.25478 13.3332 6.66927Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 8.66406C9.10457 8.66406 10 7.76863 10 6.66406C10 5.55949 9.10457 4.66406 8 4.66406C6.89543 4.66406 6 5.55949 6 6.66406C6 7.76863 6.89543 8.66406 8 8.66406Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#0A77FF',
    },
  },
};
</script>
